import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { KpiCardComponent } from '../../components/kpi-card/kpi-card.component';
import { DEVOPS_KPIS } from '../../models/devops-mock.data';

@Component({
  selector: 'app-devops-kpis',
  imports: [TranslatePipe, KpiCardComponent],
  templateUrl: './devops-kpis.component.html',
  styleUrl: './devops-kpis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevOpsKpisComponent {
  protected readonly kpis = DEVOPS_KPIS;
}
